<template>
<v-container fluid class="cont-encuentranos">
  <v-row class="no-gutters d-flex justify-center align-center cont-line">
    <v-col cols="10" class="text-left mt-1 mb-4">
      <h1 class="txt-primary"> {{itemsec.titulo}} </h1>
    </v-col>
    <v-col cols="12" sm="5">
      <v-row class="no-gutters pa-2">
        <v-col cols="12">
          Sede Principal: Calle 39 Cra. 20 Barrio Paraiso, Villavicencio, Colombia
          <br>
          Teléfono Conmutador: (608) 681 80 80
        </v-col>
        <v-col cols="12" class="text-center pa-2">
         <iframe class="frame-mapa" src="https://www.google.com/maps/embed?pb=!4v1649802379851!6m8!1m7!1sAOxQkfIE5mmjZ0sFmUdEMg!2m2!1d4.151458002919882!2d-73.62004146974962!3f287.72529701469114!4f-6.886785158507848!5f0.4592799312218649" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12" sm="5" class="pa-2">
      <v-card>
        <v-tabs
          v-model="tab"
          background-color="primary accent-4"
          centered
          dark
          icons-and-text
          height="50"
        >
          <v-tabs-slider></v-tabs-slider>

          <v-tab  v-for="(i, idx) in social"
            :key="'socialheader-'+idx"
            :href="'#tab-'+idx">
            <span class="font-1">
              {{i.name}}
            </span>
            <v-icon>{{i.icon}}</v-icon>
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
          <v-tab-item
            v-for="(i, idx) in social"
            :key="'social-'+idx"
            :value="'tab-' +idx"
          >
            <v-card flat>
              <v-card-text class="text-center">
                <span class="mx-auto text-center cont-frame" v-html="i.conthtml"></span>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </v-col>
  </v-row>

</v-container>
</template>
<script>
export default {
  data () {
    return {
      itemsec: {
        titulo: 'Encuéntranos y síguenos'
      },
      tab: null,
      social: [
        {
          name: 'facebook',
          icon: 'mdi-facebook',
          conthtml: ' <iframe src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Feaavesp%2F&tabs=timeline&width=340&height=500&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId=1548366258674310" width="340" height="400" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe> '
        },
        {
          name: 'Instagram',
          icon: 'mdi-instagram',
          conthtml: '<iframe  id="instagram-embed-0" src="https://www.instagram.com/p/CEt2qYYAvDY/embed/captioned/?cr=1&amp;v=12&amp;rd=http%3A%2F%2Fwww.lacalera-cundinamarca.gov.co&amp;rp=%2FPaginas%2Fdefault.aspx#%7B%22ci%22%3A0%2C%22os%22%3A1219.1649999003857%2C%22ls%22%3A430.74500001966953%2C%22le%22%3A432.62499989941716%7D" allowtransparency="true" allowfullscreen="true" frameborder="0" height="400" width="100%" data-instgrm-payload-id="instagram-media-payload-0" scrolling="no" ></iframe> '
        },
        {
          name: 'Youtube',
          icon: 'mdi-youtube',
          conthtml: '<iframe width="100%" height="400" src="https://www.youtube.com/embed/OHgMryntKUY" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen=""></iframe> '
        }

        // {
        //   name:'Twitter',
        //   icon:'mdi-twitter',
        //   conthtml:'<iframe id="twitter-widget-0" scrolling="no" frameborder="0" allowtransparency="true" allowfullscreen="true" data-widget-id="profile:eaavesp" title="Cronología de Twitter" height="500" width="100%"  ></iframe> '
        // }
      ]
    }
  },
  mounted () {

  }
}
</script>
<style lang="scss" scoped>
.cont-encuentranos{
  background-image: url(../assets/img/back-line.jpg);
  background-attachment: fixed;
  background-size: cover;
  padding: 0px;
}
.cont-line{
  background: linear-gradient(0deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 30%, rgba(255,255,255,0) 60%, rgba(255,255,255,1) 100%);
}
.cont-frame{
  div{
    min-width: 100%!important;
  }
}
.frame-mapa{
  border-radius: 10px;
  width: 90%;
  height: 400px;
  margin: 0 auto;
  border: 0;
}
</style>
